<template>
<div class="chapter">
<div class="inner_page">
<p class="ded-title"><b>DEDICATION</b></p>
<p class="ded"><i>This book is dedicated to my mother, who I affectionately call The Guru. She gave me life and made it better by teaching me to sew. Every page of this book is influenced by her brilliant ability with needle and thread.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0003_dedication.vue?01f13522